import {useQuery} from '@tanstack/react-query'
import {useContentstack} from '../../context/contentstack'
import {getEntryByUrl} from '../api/contentstack/sdk/entry'
import {useParams} from 'react-router-dom'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {BRAND_KEY_FILTER_CS} from '../../brand'

export const useGetGenericHtmlPage = () => {
    const {locale} = useMultiSite()
    const {stack} = useContentstack()
    const params = useParams()
    const entryUrl = params.rest ? `/${params.rest}` : '/'

    const getPageRes = async (entryUrl) => {
        const response = await getEntryByUrl({
            stack,
            contentTypeUid: 'generic_html_page',
            entryUrl,
            locale: locale.alias,
            brand: BRAND_KEY_FILTER_CS,
        })
        return response && response[0] ? response[0] : null
    }

    const query = useQuery(['generic_html_page', entryUrl], () => getPageRes(entryUrl))

    return query
}
